module.exports = __webpack_public_path__ + "static/media/Patch-first-lithonia-medical-center.289530ac.jpg";